import React from "react";
import Modal from "../../../../../../common/Modal";
import Icon from "../../../../../../common/Icon";

import { MenteeMatchModalTitle, SuccessIcon } from "./styles";

const SuccessfullMatch = ({ menteeName, mentorName, closeModal, isClose }) => {
  return (
    <Modal
      onClose={() => closeModal(false)}
      title={
        <MenteeMatchModalTitle>
          {menteeName} and {mentorName} have been successfully
          <br /> matched
        </MenteeMatchModalTitle>
      }
      actions={[
        {
          text: "Close",
          onClick: () => {
            closeModal(false);
            isClose(false);
          },
        },
        {
          text: "Back to Dashboard",
          onClick: () => {
            closeModal(false);
            isClose(false);
          },
        },
      ]}
    >
      <SuccessIcon>
        <svg
          width="47"
          height="47"
          viewBox="0 0 47 47"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="1.175"
            y="1.175"
            width="44.65"
            height="44.65"
            rx="22.325"
            stroke="#36CE10"
            stroke-width="2.35"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.9119 29.2535L14.0474 20.8972C13.6782 20.3711 12.9518 20.243 12.4249 20.6111C11.898 20.9792 11.7702 21.7041 12.1394 22.2302L18.7574 31.6602C19.1582 32.2312 19.9688 32.3248 20.4889 31.8601L35.9353 18.0576C36.4144 17.6295 36.4548 16.8945 36.0254 16.416C35.5961 15.9375 34.8596 15.8967 34.3805 16.3248L19.9119 29.2535Z"
            fill="#36CE10"
          />
        </svg>
      </SuccessIcon>
    </Modal>
  );
};
export default SuccessfullMatch;
